var getAsyncLocalStorage = function() {
  console.error("You should not get async storage in browser");
  return null;
};
export {
  getAsyncLocalStorage
};
